import React, { Component } from "react";
import styles from '../assets/scss/modules/template.module.scss';
import ib2bicon from "../assets/media/images/ib2b.png";
import logo from "../assets/media/logo/1.png";
import{
	MDBContainer,
  MDBCard,
  MDBCardTitle,
  MDBCardBody,
  MDBCardFooter,
	MDBRow,
	MDBCol,
} from 'mdbreact';


class InformationsEmail extends Component {

	constructor(props) {
    super(props);
  };

	componentDidMount() {
	}


  render() {
    return (
      <>
        <MDBContainer>
          <MDBCard className="transparent-card">
            <div className={styles.bodywrapper}>
              <MDBCardTitle>
              <img className="landing-ib2b" src={ib2bicon}/>
              </MDBCardTitle>
              <MDBCardBody>
              <h4>Hey Ryan, This is a test mail from InterB2B System.
              Enjoy our solution!</h4>
              <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi.</p>
              <MDBRow>
              <MDBCol>
              <img src={logo} alt="Logo" className="logo-landing"/>
              </MDBCol>
              <MDBCol>
              <h5>InterB2B GmbH</h5>
              <p>www.interb2b.de</p>
              </MDBCol>
              </MDBRow>
              </MDBCardBody>

            </div>
          </MDBCard>
        </MDBContainer>
      </>
    );
  }
}

export default  InformationsEmail;
